import { FormikHelpers, FormikValues } from 'formik';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { AprovarIndisponibilidadeLista } from 'Component/AprovarIndisponibilidade';
import Botao from 'Component/Botao';
import BotaoLink from 'Component/BotaoLink';
import Buscando from 'Component/Buscando';
import Cabecalho from 'Component/Cabecalho';
import Form, { Selecao } from 'Component/Form';
import LayoutDefault from 'Component/Layout';
import Paginacao from 'Component/Paginacao';
import SemRegistros from 'Component/SemRegistros';
import { useAppSelector } from 'Store';
import { INDISPONIBILIDADE_STATUS } from 'View/constants';
import { useRecuperarAprovarIndisponibilidadesQuery } from 'View/Service/Default/AprovarIndisponibilidades';

const Aguardando = (): React.ReactElement => {
  const usuario = useAppSelector((estado) => estado.autenticacao.usuario);
  const [searchParams, setSearchParams] = useSearchParams();
  const [visualizacao, setVisualizacao] = useState<number>(
    searchParams.get('visualizacao') || 1
  );

  const {
    data: { aprovar_indisponibilidades, paginacao } = {},
    isFetching,
    isLoading,
    refetch,
  } = useRecuperarAprovarIndisponibilidadesQuery({
    contain: ['Indisponibilidades.Usuarios', 'Aprovou'],
    options: {
      usuario_id: usuario?.id,
      status: searchParams.get('status') || '',
      tipo: searchParams.get('tipo') || '',
      visualizacao: searchParams.get('visualizacao') || 1,
    },
    page: searchParams.get('pagina') || 1,
  });

  const filtrar = (
    dados: {
      busca: string;
      status: string;
      tipo: string;
    },
    form: FormikHelpers<FormikValues>
  ) => {
    if (dados.status == '1' || dados.status == '0') {
      searchParams.set('status', dados.status);
    } else {
      searchParams.delete('status');
    }
    if (dados.tipo) {
      searchParams.set('tipo', dados.tipo);
    } else {
      searchParams.delete('tipo');
    }
    searchParams.set('pagina', '1');

    setSearchParams(searchParams);

    form.setSubmitting(false);
  };

  useEffect(() => {
    searchParams.set('visualizacao', visualizacao as unknown as string);
    setSearchParams(searchParams);
  }, [searchParams, setSearchParams, visualizacao]);

  return (
    <LayoutDefault>
      <Cabecalho
        titulo="Solicitações de folga aguardando aprovação"
        descricao="Listagem de solicitações cadastrados no banco de dados"
      />
      <Form emLinha onSubmit={filtrar} desabilitado={isFetching}>
        <div className="row">
          <div className="col-md-4 mb-3">
            <BotaoLink
              icone="calendar"
              to="/indisponibilidades"
              className="me-2"
            />
            <Botao icone="arrow-clockwise" onClick={refetch} className="me-2" />
            {usuario && ['super', 'admin'].includes(usuario.permissao) && (
              <div className="btn-group">
                <Botao
                  onClick={() => setVisualizacao(1)}
                  className={
                    searchParams.get('visualizacao') == 1 ? 'active' : ''
                  }
                >
                  Para eu aprovar
                </Botao>
                <Botao
                  onClick={() => setVisualizacao(2)}
                  className={
                    searchParams.get('visualizacao') == 2 ? 'active' : ''
                  }
                >
                  Todas
                </Botao>
              </div>
            )}
          </div>
          <div className="col-md-8 mb-3">
            <div className="hstack gap-3">
              <Selecao
                name="status"
                opcoes={INDISPONIBILIDADE_STATUS}
                padrao="Aprovação"
              />
              <Botao type="submit" icone="filter" />
            </div>
          </div>
        </div>
      </Form>
      <Buscando exibir={isLoading} />
      <SemRegistros
        carregando={isLoading}
        registros={aprovar_indisponibilidades?.length}
      />
      <div className="bg-white shadow-sm rounded">
        {aprovar_indisponibilidades?.map((indisponibilidade) => (
          <AprovarIndisponibilidadeLista
            key={`${indisponibilidade.id}-${indisponibilidade.modificado}`}
            dados={indisponibilidade}
          />
        ))}
      </div>
      <Paginacao dados={paginacao} desabilitado={isFetching} />
    </LayoutDefault>
  );
};

export default Aguardando;
